'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _Checkmark = require('./Checkmark');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Checkmark).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/base-icons/lib/components/Checkmark/index.js
// module id = 1145
// module chunks = 1